import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../state/AuthContext';
import { useCart } from '../state/CartContext';

export function Layout() {
  const { customer, logout } = useAuth();
  const { itemCount } = useCart();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/');
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar__inner">
          <Link to="/" className="brand">
            {/* The cup mark cropped from the site logo — the full lockup's
                wordmark is unreadable at header size, so it is set in type. */}
            <img
              className="brand__mark"
              src="/assets/opt/esmoothies_mark.webp"
              alt=""
              width={40}
              height={40}
            />
            <span className="brand__text">
              E-Smoothies
              <small>Order online</small>
            </span>
          </Link>

          <nav className="topnav" aria-label="Main">
            <NavLink to="/" end>
              Menu
            </NavLink>
            {customer && <NavLink to="/orders">My orders</NavLink>}
            {customer && <NavLink to="/loyalty">Loyalty</NavLink>}
            <NavLink to="/membership">Membership</NavLink>
            {customer?.role === 'Driver' && <NavLink to="/driver">My deliveries</NavLink>}
            {customer?.isStaff && (
              <>
                <NavLink to="/staff" className="topnav__staff">
                  Board
                </NavLink>
                <NavLink to="/staff/loyalty" className="topnav__staff">
                  Counter
                </NavLink>
                <NavLink to="/staff/menu" className="topnav__staff">
                  Menu
                </NavLink>
                <NavLink to="/staff/drivers" className="topnav__staff">
                  Drivers
                </NavLink>
                <NavLink to="/staff/customers" className="topnav__staff">
                  Customers
                </NavLink>
                <NavLink to="/staff/memberships" className="topnav__staff">
                  Members
                </NavLink>
                <NavLink to="/staff/branches" className="topnav__staff">
                  Branches
                </NavLink>
                <NavLink to="/staff/quotes" className="topnav__staff">
                  Quotes
                </NavLink>
                <NavLink to="/staff/careers" className="topnav__staff">
                  Hiring
                </NavLink>
                {(customer.role === 'Admin' || customer.role === 'SuperAdmin') && (
                  <NavLink to="/staff/settings" className="topnav__staff">
                    Settings
                  </NavLink>
                )}
              </>
            )}
            <NavLink to="/cart" className="topnav__cart">
              Cart
              {itemCount > 0 && (
                <span className="badge" aria-label={`${itemCount} items in cart`}>
                  {itemCount}
                </span>
              )}
            </NavLink>
          </nav>

          <div className="topbar__account">
            {customer ? (
              <>
                <span className="topbar__hello">
                  Hi, {customer.fullName.split(' ')[0]}
                </span>
                <button type="button" className="btn btn--ghost btn--sm" onClick={handleLogout}>
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn--ghost btn--sm">
                  Sign in
                </Link>
                <Link to="/register" className="btn btn--primary btn--sm">
                  Register
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="footer">
        <p>
          <strong>E-Smoothies</strong> · Randburg Square Food Court, Pretoria Avenue, Ferndale
        </p>
        <p>
          Delivering across <strong>Randburg</strong> and <strong>Sandton</strong> — at the same
          prices you pay in store.
        </p>
        <p>
          <a href="/">Back to the main site</a> · <a href="tel:+27729820176">072 982 0176</a>
        </p>
        {/* The only way anyone discovers driver sign-up. Without a link here it
            existed at a URL nobody could find. Shown to everyone, including
            signed-out visitors — the sign-in prompt comes after they click. */}
        <p>
          <Link to="/driver/signup" className="footer__driver">
            Want to deliver for E-Smoothies? Apply here
          </Link>
        </p>
      </footer>
    </div>
  );
}
